<template>
  <div>
    <a href="https://www.embo.org/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/embo.png"
        alt="EMBO"
        title="EMBO" />
      <img v-else src="./img/embo-darkMode.png" alt="EMBO" title="EMBO" />
    </a>
    <a href="https://www.embl.de/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/embl.png"
        alt="EMBL"
        title="EMBL" />
      <img v-else src="./img/embl-darkMode.png" alt="EMBL" title="EMBL" />
    </a>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpg" alt="ISCB" title="ISCB" />
    </a>
    <a href="http://www.sbforum.org/" rel="nofollow">
      <img src="./img/sbf.jpg" alt="Systems Biology Forum" title="Systems Biology Forum" />
    </a>
    <a href="http://www.esf.org/" rel="nofollow">
      <img src="./img/esf.jpg" alt="ESF" title="ESF" />
    </a>
    <a href="http://www.enfin.org/page.php" rel="nofollow">
      <img src="./img/enfin.jpg" alt="ENFIN" title="ENFIN" />
    </a>
    <a href="http://www.elixir-europe.org/page.php" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/ELIXIR.png"
        alt="ELIXIR"
        title="ELIXIR" />
      <img v-else src="./img/ELIXIR-darkMode.png" alt="ELIXIR" title="ELIXIR" />
    </a>
    <a href="http://www.4dconcepts.de" rel="nofollow">
      <img src="./img/4d_concepts.png" alt="4D Concepts" title="4D Concepts" />
    </a>
  </div>
</template>

<script setup>
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>
